module.exports = __webpack_public_path__ + "img/fabricacion.3e720f44.png";